// Browser polyfill for Node's crypto.randomBytes (used by sockjs-client / react-dev-utils).
// Uses Web Crypto API; provides minimal Buffer-like result for .toString('hex').

function randomBytes(size) {
  const bytes = new Uint8Array(size);
  const webCrypto = typeof window !== 'undefined' && window.crypto;
  if (webCrypto && webCrypto.getRandomValues) {
    webCrypto.getRandomValues(bytes);
  } else {
    // Fallback for very old environments (shouldn't happen in modern browsers)
    for (let i = 0; i < size; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return {
    toString(encoding) {
      if (encoding === 'hex') {
        return Array.from(bytes)
          .map((b) => b.toString(16).padStart(2, '0'))
          .join('');
      }
      return Array.from(bytes).join('');
    },
  };
}

module.exports = { randomBytes };
